var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DowntimeModel_asset_id, _DowntimeModel_wo_id, _DowntimeModel_company_id, _DowntimeModel_started_at, _DowntimeModel_ended_at;
export class DowntimeModel {
    constructor(data = {}) {
        _DowntimeModel_asset_id.set(this, void 0);
        _DowntimeModel_wo_id.set(this, void 0);
        _DowntimeModel_company_id.set(this, void 0);
        _DowntimeModel_started_at.set(this, void 0);
        _DowntimeModel_ended_at.set(this, void 0);
        // Ensure data is an object
        const safeData = data || {};
        __classPrivateFieldSet(this, _DowntimeModel_asset_id, safeData.asset_id || '', "f");
        __classPrivateFieldSet(this, _DowntimeModel_wo_id, safeData.wo_id || '', "f");
        __classPrivateFieldSet(this, _DowntimeModel_company_id, safeData.company_id || '', "f");
        // Handle date fields - store as Unix timestamps in milliseconds
        __classPrivateFieldSet(this, _DowntimeModel_started_at, safeData.started_at ?
            (typeof safeData.started_at === 'number' ? safeData.started_at : Date.now()) :
            Date.now(), "f");
        __classPrivateFieldSet(this, _DowntimeModel_ended_at, safeData.ended_at !== undefined ?
            (typeof safeData.ended_at === 'number' ? safeData.ended_at : null) :
            null, "f");
    }
    // Getters and Setters
    get asset_id() {
        return __classPrivateFieldGet(this, _DowntimeModel_asset_id, "f");
    }
    set asset_id(asset_id) {
        __classPrivateFieldSet(this, _DowntimeModel_asset_id, asset_id, "f");
    }
    get wo_id() {
        return __classPrivateFieldGet(this, _DowntimeModel_wo_id, "f");
    }
    set wo_id(wo_id) {
        __classPrivateFieldSet(this, _DowntimeModel_wo_id, wo_id, "f");
    }
    get company_id() {
        return __classPrivateFieldGet(this, _DowntimeModel_company_id, "f");
    }
    set company_id(company_id) {
        __classPrivateFieldSet(this, _DowntimeModel_company_id, company_id, "f");
    }
    get started_at() {
        return __classPrivateFieldGet(this, _DowntimeModel_started_at, "f");
    }
    set started_at(started_at) {
        __classPrivateFieldSet(this, _DowntimeModel_started_at, started_at, "f");
    }
    get ended_at() {
        return __classPrivateFieldGet(this, _DowntimeModel_ended_at, "f");
    }
    set ended_at(ended_at) {
        __classPrivateFieldSet(this, _DowntimeModel_ended_at, ended_at, "f");
    }
    // Business logic methods
    isActive() {
        return __classPrivateFieldGet(this, _DowntimeModel_ended_at, "f") === null;
    }
    isCompleted() {
        return __classPrivateFieldGet(this, _DowntimeModel_ended_at, "f") !== null;
    }
    getDuration() {
        if (__classPrivateFieldGet(this, _DowntimeModel_ended_at, "f") === null)
            return null;
        return __classPrivateFieldGet(this, _DowntimeModel_ended_at, "f") - __classPrivateFieldGet(this, _DowntimeModel_started_at, "f");
    }
    getDurationInHours() {
        const duration = this.getDuration();
        if (duration === null)
            return null;
        return duration / (1000 * 60 * 60);
    }
    getDurationInDays() {
        const duration = this.getDuration();
        if (duration === null)
            return null;
        return duration / (1000 * 60 * 60 * 24);
    }
    // Serialization methods
    toJSON() {
        const json = {
            asset_id: __classPrivateFieldGet(this, _DowntimeModel_asset_id, "f"),
            wo_id: __classPrivateFieldGet(this, _DowntimeModel_wo_id, "f"),
            company_id: __classPrivateFieldGet(this, _DowntimeModel_company_id, "f"),
            started_at: __classPrivateFieldGet(this, _DowntimeModel_started_at, "f"),
            ended_at: __classPrivateFieldGet(this, _DowntimeModel_ended_at, "f"),
        };
        return json;
    }
    toFirestore() {
        return {
            asset_id: __classPrivateFieldGet(this, _DowntimeModel_asset_id, "f"),
            wo_id: __classPrivateFieldGet(this, _DowntimeModel_wo_id, "f"),
            company_id: __classPrivateFieldGet(this, _DowntimeModel_company_id, "f"),
            started_at: __classPrivateFieldGet(this, _DowntimeModel_started_at, "f"),
            ended_at: __classPrivateFieldGet(this, _DowntimeModel_ended_at, "f"),
        };
    }
}
_DowntimeModel_asset_id = new WeakMap(), _DowntimeModel_wo_id = new WeakMap(), _DowntimeModel_company_id = new WeakMap(), _DowntimeModel_started_at = new WeakMap(), _DowntimeModel_ended_at = new WeakMap();
//# sourceMappingURL=DowntimeModel.js.map